/* eslint-disable no-unused-vars */
import Form from "react-bootstrap/Form";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import { RotatingLines } from "react-loader-spinner"; // Import the spinner
import "./Login.css";
import { hitApi } from "./utils/apiCall";
import { useAuth } from "./context/AuthContext";

const Login = () => {
  const [mobileNumber, setMobileNumber] = useState(""); // Input field for mobile number
  const [otp, setOtp] = useState("");
  const [otpReceived, setOtpReceived] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [receivedOtp, setReceivedOtp] = useState(""); // Store OTP received from API
  const [username, setUsername] = useState(""); // Store username received from API
  const [authToken, setAuthToken] = useState(""); // Store authToken received from OTP verification
  const navigate = useNavigate(); // Hook to navigate to home page
  const { setIsLoggedIn } = useAuth(); // ✅ Use context to update auth status

  const [showOtpText, setShowOtpText] = useState(false);

  useEffect(() => {
    if (receivedOtp) {
      setShowOtpText(true);
      const timer = setTimeout(() => setShowOtpText(false), 10000); // Hide after 10s
      return () => clearTimeout(timer);
    }
  }, [receivedOtp]);

  // Handle mobile number input change
  const handleMobileNumberChange = (e) => {
    setMobileNumber(e.target.value);
  };

  // Handle OTP input change
  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  async function handleGetOtp(e) {
    e.preventDefault();
    setLoading(true);
    setOtpError(""); // Clear any previous errors
    const fd = new FormData();
    fd.append("username", mobileNumber);
    const res = await hitApi("/auth/loginCurl", "verifyAndSendOTP", fd);
    setLoading(false);
    console.log(res);
    if (res.success) {
      localStorage.setItem("user-phno", mobileNumber);
      setOtpReceived(true);
      setReceivedOtp(res.data.otp); // Store OTP from server
      setUsername(res.data.username); // Store the username for later verification
      toast.success(res.message);
      // toast.error("Invalid mobile number.");
    } else {
      toast.error(res.message);
    }
  }

  // Handle form submission to verify OTP
  const handleVerifyOtp2 = async (e) => {
    e.preventDefault();
    setLoading(true);
    setOtpError(""); // Clear any previous errors

    localStorage.setItem("usernameId", username);

    const fd = new FormData();
    fd.append("username", username); // Send the username received from the OTP API
    fd.append("otp", otp); // Send entered OTP
    fd.append("programType", "verifyOtp"); // Specify program type as OTP verification
    let response;
    try {
      response = await fetch(
        "https://api.sarvajna.co.in/owner/teacher/loginCurl",

        {
          method: "POST",
          body: fd,
        }
      );

      const data = await response.json();

      if (data.success) {
        console.log(data.data);
        data.data && localStorage.setItem("user-name", data.data.name);
        if (data?.data?.authKey) {
          const authToken = data.data.authKey;
          setAuthToken(authToken); // Set it in the state
          await callGetTokenApi(authToken); // Call the getToken API
          toast.success("Login successful!");
        } else {
          toast.error("authToken is missing in response data.");
        }
      } else {
        toast.error("Failed to verify OTP.");
      }
    } catch (error) {
      toast.error("Failed to verify OTP.");
    } finally {
      setLoading(false);
    }
  };

  async function handleVerifyOtp(e) {
    e.preventDefault();
    setLoading(true);
    setOtpError("");
    const fd = new FormData();
    fd.append("username", username);
    fd.append("otp", otp);
    fd.append("playerId", "");
    const res = await hitApi("/auth/loginCurl", "verifyOtp", fd);
    console.log(res);

    setLoading(false);
    console.log(res);
    if (res.success) {
      localStorage.setItem("user-name", res.data.name);
      localStorage.setItem("user-id", res.data.username);
      localStorage.setItem("branch-id", res.data.branch_id);
      await callGetTokenApi(res.data.authToken);
      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
  }

  const callGetTokenApi = async (authToken) => {
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("authToken", authToken);
      fd.append("programType", "getToken");

      const res = await hitApi("/token/tokenCurl", "getToken", fd);
      console.log(res);

      if (res.success) {
        localStorage.setItem("authToken", authToken);
        localStorage.setItem("token", res.data);

        setIsLoggedIn(true); // ✅ Tell context you're now logged in
        navigate("/home"); // ✅ Navigate to home after login
      } else {
        toast.error("Failed to get token.");
      }
    } catch (error) {
      toast.error("Failed to get token.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Toaster position="top-center" /> {/* Add Toaster here */}
      <div className="login-wrapper d-flex" style={{ paddingTop: "90px" }}>
        <div className="container">
          <div className="text-center px-4">
            <img
              className="login-intro-img"
              src="assets/img/bg-img/LOGO PNG-min.png"
              alt="Login Illustration"
              width={"200px"}
            />
          </div>

          <div className="register-form mt-4">
            <form onSubmit={otpReceived ? handleVerifyOtp : handleGetOtp}>
              <div className="form-group">
                <input
                  className="form-control large-input"
                  type="text"
                  inputMode="numeric"
                  id="mobileNumber"
                  placeholder="Mobile Number"
                  value={mobileNumber}
                  onChange={handleMobileNumberChange}
                  disabled={loading}
                />
              </div>

              {otpReceived && (
                <div className="otp-display mt-3">
                  <p>Your OTP: {receivedOtp}</p>
                </div>
              )}

              {/* {otpReceived && (
                <div className="form-group mt-3">
                  <input
                    className="form-control large-input"
                    type="text"
                    id="otp"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={handleOtpChange}
                  />
                </div>
              )} */}

              {otpReceived && showOtpText && (
                <div
                  className="text-center mt-3"
                  style={{ fontSize: "14px", color: "#198754" }}
                >
                  Your OTP is <strong>{receivedOtp}</strong>
                </div>
              )}

              {otpReceived && (
                <div className="my-3">
                  <OtpInput
                    length={4}
                    onOtpChange={(otpValue) => setOtp(otpValue)}
                  />
                </div>
              )}
              <button
                className="btn btn-primary w-100 large-button"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <RotatingLines
                    strokeColor="white"
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="24"
                    visible={true}
                  />
                ) : otpReceived ? (
                  "Verify OTP"
                ) : (
                  "Get OTP"
                )}
              </button>
            </form>

            {otpError && (
              <div
                style={{ color: "red", fontSize: "13px", marginTop: "10px" }}
              >
                {otpError}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;

const OtpInput = ({ length = 4, onOtpChange }) => {
  const [otp, setOtp] = useState(Array(length).fill(""));
  const inputRefs = useRef([]);

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  const handleChange = (index, event) => {
    const value = event.target.value;
    if (value === "" || /^\d$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      onOtpChange(newOtp.join(""));

      if (value !== "" && index < length - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const pastedData = event.clipboardData.getData("text").replace(/\D/g, "");

    const newOtp = [...otp];
    for (let i = 0; i < length; i++) {
      if (pastedData[i]) {
        newOtp[i] = pastedData[i];
      }
    }
    setOtp(newOtp);
    onOtpChange(newOtp.join(""));

    const lastIndex = Math.min(pastedData.length, length) - 1;
    inputRefs.current[lastIndex]?.focus();
  };

  return (
    <div className="d-flex flex-row justify-content-evenly">
      {otp.map((digit, index) => (
        <Form.Control
          key={index}
          type="text"
          inputMode="numeric"
          maxLength="1"
          className="mx-1 text-center"
          value={digit}
          onChange={(e) => handleChange(index, e)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          ref={(input) => (inputRefs.current[index] = input)}
          style={{
            width: "3rem",
            height: "3rem",
            fontSize: "1.5rem",
            textAlign: "center",
          }}
        />
      ))}
    </div>
  );
};
